// extracted by mini-css-extract-plugin
module.exports = {"list":"IndicatorsRow_list__yBR6n","item":"IndicatorsRow_item__38Orq","content":"IndicatorsRow_content__3QzbZ"};